import { fileManagementClient } from '@lib/documentServiceClient';
import { createFileService } from '@workpay/ds-shared/services/fileService';

export const dsFileService = createFileService(fileManagementClient);
